import { FuneralAndEstateExpenseType } from '/@/modules/liability/enums/FuneralAndEstateExpenseType';
import { DocumentSubType } from '/@/modules/document/enums/DocumentSubType';

export class FuneralAndEstateExpenseLiabilityMeta {
  /**
   * @var {string}
   */
  type;

  /**
   * @var {string}
   */
  nameOfIssuer;

  /**
   * @var {boolean}
   */
  isRecurring;

  constructor(model = {}) {
    this.type = model.type;
    this.nameOfIssuer = model.nameOfIssuer;
    this.isRecurring = model.isRecurring ?? false;
  }

  /**
   * @returns {boolean}
   */
  get isOtherFuneralAndEstateExpense() {
    return this.type === FuneralAndEstateExpenseType.OTHER.key;
  }

  /**
   * @returns {boolean}
   */
  get isAppraisalFees() {
    return this.type === FuneralAndEstateExpenseType.APPRAISAL_FEES.key;
  }

  /**
   * @returns {boolean}
   */
  get isLegalFees() {
    return this.type === FuneralAndEstateExpenseType.LEGAL_FEES.key;
  }

  /**
   * @returns {boolean}
   */
  get isFuneralHomeFees() {
    return this.type === FuneralAndEstateExpenseType.FUNERAL_HOME_FEES.key;
  }

  /**
   * @returns {boolean}
   */
  get isProbateRefereeFee() {
    return this.type === FuneralAndEstateExpenseType.PROBATE_REFEREE_FEE.key;
  }

  /**
   * @return {string}
   */
  get documentSubType() {
    return this.isAppraisalFees
      ? DocumentSubType.LIABILITY_APPRAISAL.key
      : DocumentSubType.LIABILITY_BILL.key;
  }

  /**
   * @returns {string}
   */
  get title() {
    return FuneralAndEstateExpenseType.getByKey(this.type).value;
  }
}
